import React, { useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';

import { makeStyles } from '@material-ui/core/styles';
import FlowSteps from '../shared/FlowSteps';



const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => (styles(theme)));

const styles = (theme) => {

    return ({
        dialog: {
            "& .MuiDialog-paper": {
                margin: '0 !important',
                borderRadius: 14,
                border: `1px solid ${theme.palette.divider}`
            },

        },
        head: {
            display: 'grid',
            gap: theme.spacing(1.5),
            padding: theme.spacing(2.5, 3, 2),
            borderBottom: `1px solid ${theme.palette.divider}`,
            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(2)
            }
        },
        titleRow: {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: theme.spacing(1)
        },
        title: {
            fontSize: '1.2rem',
            fontWeight: 600,
            lineHeight: 1.3
        },
        subtitle: {
            color: theme.palette.text.secondary,
            fontSize: '0.9rem',
            marginTop: 2
        },
        close: {
            marginTop: -6,
            marginRight: -10
        },
        content: {
            padding: theme.spacing(3),
            [theme.breakpoints.down('xs')]: {
                padding: theme.spacing(2)
            }
        }
    })

}

/**
 * The slide-up panel the renewal flows run in. With a title it draws a header
 * (title, subtitle, close button) and, with steps, a step bar under it.
 */
export default function SlideInModal({ children, openModal, handleClose, header, title, subtitle, steps, activeStep }) {
    const [open, setOpen] = React.useState(openModal);
    const classes = useStyles();

    useEffect(() => {
        setOpen(openModal)
    }, [openModal])


    return (
        <div>

            <Dialog
                className={classes.dialog}
                open={open}
                TransitionComponent={Transition}
                keepMounted
                fullWidth={true}
                maxWidth='md'
                onClose={handleClose}
                aria-labelledby={title ? 'slide-in-title' : 'alert-dialog-slide-title'}
                aria-describedby="alert-dialog-slide-description"
            >
                {title && <div className={classes.head}>
                    <div className={classes.titleRow}>
                        <div>
                            <Typography id="slide-in-title" component="h2" className={classes.title}>{title}</Typography>
                            {subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
                        </div>
                        {handleClose && <IconButton aria-label="Close" className={classes.close} onClick={handleClose}><CloseIcon /></IconButton>}
                    </div>
                    {steps && steps.length > 0 && <FlowSteps steps={steps} active={activeStep || 0} />}
                </div>}
                <DialogContent className={title ? classes.content : undefined}>
                    {children}
                </DialogContent>

            </Dialog>
        </div>
    );
}
